module.exports = __webpack_public_path__ + "static/media/united-states-of-america.a035edad.svg";